import * as React from 'react';

import * as styles from './Feedback.css';

interface IFeedbackProps {
  children: React.ReactNode;
}

export const Feedback: React.FC<IFeedbackProps> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
